import React, { useState, useEffect } from "react";
import Modal from "react-bootstrap/Modal";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {
  AllOwnerTypeDetails,
  CreateOwnerTypeDetails,
  UpdateOwnerTypeDetails,
  getOwnerTypeById,
} from "../../Apis/ownerTypeApi";
import TableComponent from "../../Common/TableComponent/tableComponent";
import Loader from "../../Common/Loader/loader";
import { useNavigate } from "react-router-dom";
import { withTranslation } from "react-i18next";
import * as XLSX from "xlsx"; // Import XLSX library for Excel operations
import ExcelJS from "exceljs";

const OwnerType = ({ t }) => {
  const navigate = useNavigate();
  const headers = [
    "ownerType",
    "ownerName",
    "MobileNumber",
    "companyName",
    "city",
    "ownerTypeCode",
    "status",
    "actions",
  ];
  const [lgShow, setLgShow] = useState(false);
  const [ownerTypeDetails, setOwnerTypeDetails] = useState([]);
  const [ownerTypeNames, setOwnerTypeName] = useState([]);
  const [editOwnerTypeData, setEditOwnerTypeData] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [formSubmitted, setFormSubmitted] = useState(false);
  const [sortedData, setSortedData] = useState([]); // New state to store sorted data
  const [excelData, setExcelData] = useState([]);
  const [originalData, setOriginalData] = useState([]);
  const [sortConfig, setSortConfig] = useState(null);
  const [filterOriginalOwnerTypeData, setFilterOriginalOwnerTypeData] = useState([]);
  const [formInput, setFormInput] = useState({
    ownerTypeName: "",
    ownerName: "",
    ownerContact: "",
    companyName: "",
    cityName: "",
    details: "",
    isActive: true,
    ownerTypeCode: "",
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    let sanitizedValue = value; // Initialize sanitized value with input value
    if (name === "ownerContact") {
      // Remove non-numeric characters (ensures only digits)
      sanitizedValue = value.replace(/\D/g, "");
  
      // Ensure the first digit is 6, 7, 8, or 9
      if (sanitizedValue.length > 0 && !/^[6789]/.test(sanitizedValue)) {
        return; // Stop updating state if the first digit is invalid
      }
  
      // Limit input to 10 digits
      sanitizedValue = sanitizedValue.slice(0, 10);
    } 
    else if (
      ["ownerName", "ownerTypeName", "companyName", "cityName", "details"].includes(name)
    ) {
      // Allow only alphabets and spaces, ensuring only one space between words
      sanitizedValue = value
        .replace(/[^A-Za-z\s]/g, "") // Allow only alphabets and spaces
        .replace(/^\s+/, "") // Remove leading spaces
        .replace(/\s{2,}/g, " "); // Replace multiple spaces with a single space
    } else if (name === "ownerTypeCode") {
      // Allow letters, numbers, and hyphen only
      sanitizedValue = value.replace(/[^A-Za-z0-9-]/g, "");
    }

    // Update the state
    setFormInput((prevData) => ({ ...prevData, [name]: sanitizedValue }));
  };



  const handleClose = () => {
    setLgShow(false);
    setIsLoading(true);
    setEditOwnerTypeData(null);
    setTimeout(() => setIsLoading(false), 1000);
    setFormInput({
      ownerTypeName: "",
      ownerName: "",
      ownerContact: "",
      companyName: "",
      cityName: "",
      details: "",
      isActive: "",
      ownerTypeCode: "",
    });
    setFormSubmitted(false);
  };

  const handleShow = () => {
    setLgShow(true);
    setIsLoading(true);
    setTimeout(() => setIsLoading(false), 1000);
    setFormInput({
      ownerTypeName: "",
      ownerName: "",
      ownerContact: "",
      companyName: "",
      cityName: "",
      details: "",
      isActive: true,
      ownerTypeCode: "",
    });
    setEditOwnerTypeData(null);
  };

  const handleEditOwnerTypeData = (selectedOwnerTypeDetails) => {
    setEditOwnerTypeData(selectedOwnerTypeDetails);
    setIsLoading(true);
    setTimeout(() => setIsLoading(false), 1000);
    setFormInput({
      ownerTypeId: selectedOwnerTypeDetails.ownerTypeId,
      ownerTypeName: selectedOwnerTypeDetails.ownerTypeName,
      ownerName: selectedOwnerTypeDetails.ownerName,
      ownerContact: selectedOwnerTypeDetails.ownerContact,
      companyName: selectedOwnerTypeDetails.companyName,
      cityName: selectedOwnerTypeDetails.city,
      details: selectedOwnerTypeDetails.details,
      isActive: selectedOwnerTypeDetails.isActive,
      ownerTypeCode: selectedOwnerTypeDetails.ownerTypeCode,
    });
    setLgShow(true);
  };

  const fetchOwnerDetails = async () => {
    try {
      setIsLoading(true);
      const allOwnerTypeResponse = await AllOwnerTypeDetails();
      if (!allOwnerTypeResponse) {
        console.error("Owner type response is undefined:", allOwnerTypeResponse);
        return;
      }
      
      const mappedAllOwnerTypeData = allOwnerTypeResponse?.map(station => ({
        ...station,
        status: station.isActive ? "Active" : "InActive",
      }));

      const ownerData = allOwnerTypeResponse.map((station) => {
        return {
          ...station,
          ownerName: station.ownerName || "N/A",
          companyName: station.companyName || "N/A",
          city: station.city || "N/A",
          ownerTypeCode: station.ownerTypeCode || "N/A",
          ownerType: station.ownerTypeName || "N/A",
          MobileNumber: station.ownerContact || "N/A",
          status: station.isActive ? "Active" : "InActive",
        };
      });

      // Sort the data based on the isActive field
      const sortedRouteData = ownerData.sort((a, b) => {
        if (a.isActive === b.isActive) {
          return 0;
        }
        return a.isActive ? -1 : 1;
      });

      setOwnerTypeDetails(allOwnerTypeResponse);
      setSortedData(sortedRouteData);
      setOriginalData(mappedAllOwnerTypeData);
      setOwnerTypeName(sortedRouteData);
      setFilterOriginalOwnerTypeData(sortedRouteData);
    } catch (error) {
      console.error("Error fetching owner type data:", error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchOwnerDetails();
  }, []);

  const handleCreateOwnerTypeDetails = async (e) => {
    e.preventDefault();
    setFormSubmitted(true);

    //   const firstDigit = formInput.ownerContact.charAt(0);
    // if (!["6", "7", "8", "9"].includes(firstDigit)) {
    //    toast.error("Mobile number should start with 6, 7, 8, or 9", {
    //      position: "top-right",
    //      autoClose: 5000,
    //      hideProgressBar: false,
    //    });
    //   return; // Prevent form submission
    // }
    try {
      setIsLoading(true);
      if (editOwnerTypeData) {
        // Perform validation for required fields only when adding new data
        if (
          !formInput.ownerTypeName ||
          !formInput.ownerName ||
          !formInput.ownerTypeCode
        ) {
          // toast.error("Please fill in all required fields.", {
          //   position: "top-right",
          //   autoClose: 5000,
          //   hideProgressBar: false,
          // });
          return;
        }

        const isDuplicateCode = ownerTypeDetails.some(
          (ownerType) =>
            ownerType.ownerTypeCode === formInput.ownerTypeCode &&
            ownerType.ownerTypeId !== editOwnerTypeData?.ownerTypeId // Exclude the current edited owner type if any
        );
        if (isDuplicateCode) {
          // If duplicate code found, show error toast and return
          toast.error(
            "Owner Type Code already exists. Please choose a different one.",
            {
              position: "top-right",
              autoClose: 5000,
              hideProgressBar: false,
            }
          );
          return;
        }
      }
      if (editOwnerTypeData) {
        const updatedOwnerTypeData = { ...formInput };
        await UpdateOwnerTypeDetails(updatedOwnerTypeData);
        toast.success("Owner Type Details updated successfully");
      } else {
        await CreateOwnerTypeDetails(formInput);
        toast.success("Owner Type Details added successfully");
      }
      fetchOwnerDetails();
      handleClose();
    } catch (error) {
      if (error.response) {
        const { status, data } = error.response;
        if (status === 400) {
          // Handle 400 status code errors with validation errors
          const validationErrors = data;
          // for (const field in validationErrors) {
          toast.error(validationErrors, {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
          });
          // }
        } else if (status === 409) {
          // Handle 409 status code errors
          const errorMessage = data;
          toast.error(errorMessage, {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
          });
        } else if (status === 404) {
          // Handle 409 status code errors
          const errorMessage = data;
          toast.error(errorMessage, {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
          });
        }
      } else {
        // Handle network errors or other unexpected errors
        toast.error("An error occurred. Please try again later.", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
        });
      }
    } finally {
      setIsLoading(false);
    }
  };

  // useEffect(() => {
  //   setFormInput(
  //     editOwnerTypeData || {
  //       ownerTypeName: "",
  //       ownerName: "",
  //       ownerContact: "",
  //       companyName: "",
  //       cityName: "",
  //       details: "",
  //       isActive: "",
  //       ownerTypeCode: "",
  //     }
  //   );
  // }, [editOwnerTypeData]);

  const handleViewOwnerTypeData = async (id) => {
    try {
      await new Promise((resolve) => setTimeout(resolve, 1000));
      setIsLoading(true);
      const response = await getOwnerTypeById(id);
      const ownerTypeDetails = response.data.data;
      navigate("/owner-type-details", { state: { ownerTypeDetails } });
    } catch (error) {
      //  console.log(error);
    } finally {
      setIsLoading(false);
    }
  };

  const options = { day: 'numeric', month: 'numeric', year: 'numeric' };
  const generationTime = ` ${new Date().toLocaleString('en-GB', options).replace(/\//g, '/')}`;

  const downloadAsExcel = async () => {
    // Create a new workbook and add a worksheet
    const dataToUse = sortedData.length > 0 ? sortedData : originalData;
    const currentDate = new Date();
    const formattedDate = `${currentDate.getFullYear()}-${currentDate.getMonth() + 1
      }-${currentDate.getDate()}`;
    const formattedTime = `${currentDate.getHours()}:${currentDate.getMinutes()}:${currentDate.getSeconds()}`;
    const cumulativeHeadingReport = `OwnerType Details`;
    const downloadDateTime = `Owner Type Report Generated on: ${generationTime},${formattedTime}`;
    // Calculate the length of the downloadDateTime string
    const downloadDateTimeLength = downloadDateTime.length;
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet("Zones");

    // Define styles
    const boldFont = { bold: true };

    // Add the downloadDateTime to the correct row and columns, and ensure formatting
    worksheet.addRow(["", "", downloadDateTime, ""]); // Update array length to match new cell range
    worksheet.mergeCells(1, 2, 1, 7); // Merge cells for downloadDateTime from column 2 to 4
    worksheet.getCell(1, 2).value = downloadDateTime; // Ensure the value is set after merging
    worksheet.getCell(1, 2).font = boldFont; // Set font style
    worksheet.getCell(1, 2).alignment = { horizontal: "center" }; // Center align the content

    // Apply styles to the merged cells (B1, C1, D1)
    for (let col = 2; col <= 7; col++) {
      worksheet.getCell(1, col).font = boldFont; // Set styles individually
      worksheet.getCell(1, col).alignment = { horizontal: "center" }; // Center align the cell content
    }

    // Add "Zone Details" to the correct row and columns, and ensure formatting
    worksheet.addRow(["", "", "OwnerType Details", ""]); // Update array length to match new cell range
    worksheet.mergeCells(2, 2, 2, 7); // Merge cells for Zone Details from column 2 to 4
    worksheet.getCell(2, 2).value = "OwnerType Details"; // Ensure the value is set after merging
    worksheet.getCell(2, 2).font = boldFont; // Set font style
    worksheet.getCell(2, 2).alignment = { horizontal: "center" }; // Center align the content

    // Apply styles to the merged cells (B2, C2, D2)
    for (let col = 2; col <= 7; col++) {
      worksheet.getCell(2, col).font = boldFont; // Set styles individually
      worksheet.getCell(2, col).alignment = { horizontal: "center" }; // Center align the cell content
    }


    // Add empty row for spacing
    worksheet.addRow([""]);

    // Add table header row with bold font
    const tableHeaderRow = worksheet.addRow([
      "S.No",
      "Owner Type",
      "Owner Name",
      "Mobile Number",
      "Company Name",
      "City",
      "Owner Type Code",
      "Status"
    ]);

    tableHeaderRow.eachCell({ includeEmpty: true }, (cell, colNumber) => {
      cell.font = boldFont;
      cell.alignment = { horizontal: "left" }; // Left align the cell content
      if (colNumber >= 1 && colNumber <= 8) {
        // Apply background color only to specific cells
        cell.fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: "F6B1B1" } // Red background color
        };
      }
    });

    // Add data rows
    ownerTypeNames.forEach((item, index) => {
      worksheet.addRow([
        index + 1,
        item.ownerTypeName,
        item.ownerName,
        item.ownerContact,
        item.companyName,
        item.city,
        item.ownerTypeCode,
        item.status,
      ]).eachCell({ includeEmpty: true }, (cell, colNumber) => {
        if (colNumber >= 1 && colNumber <= 7) {
          // Align the columns from 1 to 4 to the left
          cell.alignment = { horizontal: "left" };
        } else {
          // Align the rest of the columns to the center
          cell.alignment = { horizontal: "center" };
        }
      });
    });

    // Set column widths dynamically based on content
    worksheet.columns = [
      { width: 5 },
      { width: 20 },
      { width: 20 },
      { width: 20 },
      { width: 20 },
      { width: 20 },
      { width: 20 },
      { width: 20 },
    ];

    // Save the workbook to a file
    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = "OwnerTypeDetails.xlsx";
    a.click();
    URL.revokeObjectURL(url);
  };

  let storedPermissions = localStorage.getItem('permissionId')
  const permissionValues1 = JSON.parse(localStorage.getItem('rolePermissions')) || {};
  let canWriteValue = null;

  // Convert storedPermissions to a number (if needed)
  storedPermissions = parseInt(storedPermissions, 10);

  // Find the matching roleToPermissionMapping object
  const matchingPermission = permissionValues1.find(mapping => mapping.permissionId === storedPermissions);

  if (matchingPermission) {
    canWriteValue = matchingPermission.canWrite;
    console.log(`canWrite value for permission ID ${storedPermissions}:`, canWriteValue);
  } else {
    console.log(`No match found for permission ID ${storedPermissions}`);
  }

  const handleSort = (sortConfig) => {
    // Assuming you have a method to sort data based on sortConfig
    const sorted = [...ownerTypeNames].sort((a, b) => {
      if (sortConfig.order === 'asc') {
        return a[sortConfig.column] > b[sortConfig.column] ? 1 : -1;
      } else {
        return a[sortConfig.column] < b[sortConfig.column] ? 1 : -1;
      }
    });

    setSortedData(sorted); // Update the sorted data
  };
  const handleSortAndExport = async () => {
    if (sortConfig) {
      handleSort(sortConfig); // Apply sorting
      await new Promise((resolve) => setTimeout(resolve, 100)); // Wait for state update
    }
    const dataToExport = sortConfig ? sortedData : originalData; // Use sorted or original data
    downloadAsExcel(dataToExport); // Export the data
  };

  const searchOwnerTypeHandler = (e) => {
    const term = e.target.value.toLowerCase();
    const data = filterOriginalOwnerTypeData.filter(item => item?.ownerType?.toLowerCase()?.includes(term) || item?.ownerTypeCode?.toLowerCase()?.includes(term));
    setOwnerTypeName(data);
  }
  return (
    <>
      <div style={{ width: "100%" }}>
        <div className="content">
          <div className="page-content">
            <div className="page-header">

              <div className="row justify-content-between">
                <div className="col-md-3">
                  <div className="form-group">
                    <input
                      placeholder="Search Owner Type or Owner Type Code"
                      type="text"
                      className="form-control bg-white"
                      onInput={searchOwnerTypeHandler}
                    />
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="d-flex justify-content-end mb-3">
                    {canWriteValue === true ?
                      <button className="button-container" onClick={handleShow}>
                        <i className="fa-solid fa-plus me-1 icon-container"></i>
                        {t("addOwnerType")}
                      </button>
                      : ''}
                    <button className="btn btn-excel"
                      onClick={handleSortAndExport}>
                      <i class="fa-solid fa-file-excel me-1 icon-container"></i> Excel
                    </button>
                  </div>
                </div>
              </div>
              <div className="card">
                <div className="card-body">
                  <div className="top-header">
                    {/* <span>{t("ownerTypeDetails")}</span> */}
                    <span>Owner Type Details</span>
                  </div>
                  <TableComponent
                    DataFetchURL={ownerTypeNames}
                    headers={headers}
                    editData={handleEditOwnerTypeData}
                    editDataDetails={editOwnerTypeData}
                    viewData={(id) => handleViewOwnerTypeData(id)}
                    onSort={handleSort}
                    skipGetCircle={true}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {isLoading && <Loader />}
      <Modal
        show={lgShow}
        size="lg"
        onHide={() => setLgShow(false)}
        aria-labelledby="example-modal-sizes-title-lg"
        backdrop="static"
      >
        <Modal.Header>
          <Modal.Title id="example-modal-sizes-title-lg">
            {editOwnerTypeData ? t("editOwnerType") : t("addOwnerType")}
          </Modal.Title>
        </Modal.Header>
        <i class="fa-solid fa-xmark close-container" onClick={handleClose}></i>
        <hr />
        <Modal.Body>
          <form onSubmit={handleCreateOwnerTypeDetails}>
            <div className="row">
              <div className="col-md-4 mb-3">
                <div className="form-group">
                  <label className="form-label">
                    {t("Owner Type Code")}
                    <span style={{ color: "#EC1117" }}> *</span>{" "}
                  </label>
                  <input
                    type="text"
                    name="ownerTypeCode"
                    className={`form-control ${formInput.ownerTypeCode || !formSubmitted
                      ? ""
                      : "input-error"
                      }`}
                    placeholder="Enter Owner Code"
                    onChange={handleInputChange}
                    value={formInput.ownerTypeCode}
                    maxLength={8}
                    disabled={!canWriteValue}
                  />
                  {!formInput.ownerTypeCode && formSubmitted && (
                    <div className="required-message">
                      {" "}
                      Owner Type Code is Required
                    </div>
                  )}
                </div>
              </div>

              <div className="col-md-4 mb-3">
                <div className="form-group">
                  <label className="form-label">
                    {t("Owner Type")}{" "}
                    <span style={{ color: "#EC1117" }}> *</span>
                  </label>
                  <input
                    type="text"
                    name="ownerTypeName"
                    className={`form-control ${formInput.ownerTypeName || !formSubmitted
                      ? ""
                      : "input-error"
                      }`}
                    placeholder="Enter Owner Type"
                    onChange={handleInputChange}
                    value={formInput.ownerTypeName}
                    maxLength={42}
                    disabled={!canWriteValue}
                  />
                  {!formInput.ownerTypeName && formSubmitted && (
                    <div className="required-message">
                      Owner Type is Required.
                    </div>
                  )}
                </div>
              </div>
              <div className="col-md-4 mb-3">
                <div className="form-group">
                  <label className="form-label">
                    {t("Owner Name")}
                    <span style={{ color: "#EC1117" }}> *</span>
                  </label>
                  <input
                    type="text"
                    name="ownerName"
                    className={`form-control ${formInput.ownerName || !formSubmitted ? "" : "input-error"
                      }`}
                    placeholder="Enter Owner Name"
                    onChange={handleInputChange}
                    value={formInput.ownerName}
                    maxLength={42}
                    disabled={!canWriteValue}
                  />
                  {!formInput.ownerName && formSubmitted && (
                    <div className="required-message">Owner Name is Required.</div>
                  )}
                </div>
              </div>
              <div className="col-md-4 mb-3">
                <div className="form-group">
                  <label className="form-label">
                    {t("Mobile Number")}
                    <span style={{ color: "#EC1117" }}> *</span>
                  </label>
                  <input
                    name="ownerContact"
                    className={`form-control ${(!formInput.ownerContact && formSubmitted) ||
                        (formInput.ownerContact &&
                          formInput.ownerContact.length < 10 &&
                          formSubmitted)
                        ? "input-error"
                        : ""
                      }`}
                    placeholder="Enter Mobile Number"
                    onChange={handleInputChange}
                    value={formInput.ownerContact}
                    maxLength={10} // Ensures max 10 digits
                    disabled={!canWriteValue}
                  />

                  {/* Display error message if mobile number is less than 10 characters */}
                  {(!formInput.ownerContact && formSubmitted) ||
                    (formInput.ownerContact &&
                      formInput.ownerContact.length < 10 &&
                      formSubmitted) ? (
                    <div className="required-message">
                      {!formInput.ownerContact
                        ? "Mobile Number is Required."
                        : "Mobile number must be 10 digits"}
                    </div>
                  ) : null}
                </div>
              </div>

              <div className="col-md-4 mb-3">
                <div className="form-group">
                  <label className="form-label">
                    {t("Company Name")}
                    {/* <span style={{ color: "#EC1117" }}> *</span> */}
                  </label>
                  <input
                    type="text"
                    name="companyName"
                    className="form-control"
                    maxLength={42}
                    placeholder="Enter Company Name"
                    onChange={handleInputChange}
                    value={formInput.companyName === "N/A" ? "" : formInput.companyName}
                    disabled={!canWriteValue}
                  />
                </div>
              </div>
              <div className="col-md-4 mb-3">
                <div className="form-group">
                  <label className="form-label">
                    {t("City")}
                    {/* <span style={{ color: "#EC1117" }}> *</span> */}
                  </label>
                  <input
                    type="text"
                    name="cityName"
                    className="form-control"
                    placeholder="Enter City Name"
                    maxLength={42}
                    onChange={handleInputChange}
                    value={formInput.cityName === "N/A" ? "" : formInput.cityName}
                    disabled={!canWriteValue}
                  />
                </div>
              </div>
              <div className="col-md-4 mb-3">
                <div className="form-group">
                  <label className="form-label">{t("Remarks")}</label>
                  {/* <span style={{ color: "#EC1117" }}> *</span> */}
                  <input
                    type="text"
                    name="details"
                    className="form-control"
                    placeholder="Enter Remarks"
                    maxLength={500}
                    onChange={handleInputChange}
                    value={formInput.details}
                    disabled={!canWriteValue}
                  />
                  {/* {!formInput.details && formSubmitted && (
                    // <div className="required-message">Remarks is Required.</div>
                  )} */}
                </div>
              </div>
            </div>
            <div className="col-md-4" style={{ marginTop: "5px" }}>
              <label className="form-label">
                {t("status")}
                <span style={{ color: "#EC1117" }}> *</span>
              </label>
              <div className="form-group" style={{ display: "flex" }}>
                <div className="form-check">
                  <input
                    type="radio"
                    className="form-check-input"
                    name="isActive"
                    id="activeRadio"
                    checked={formInput.isActive} // Check if isActive is true
                    onChange={() =>
                      handleInputChange({
                        target: { name: "isActive", value: true }, // Set value to true
                      })
                    }
                  />

                  <label className="form-check-label" htmlFor="activeRadio">
                    Active
                  </label>
                </div>
                <div className="form-check" style={{ marginLeft: "40px" }}>
                  <input
                    type="radio"
                    className="form-check-input"
                    name="isActive"
                    id="inactiveRadio"
                    checked={formInput.isActive === false}
                    onChange={() =>
                      handleInputChange({
                        target: { name: "isActive", value: false }, // Set value to false
                      })
                    }
                  />

                  <label className="form-check-label" htmlFor="inactiveRadio">
                    InActive
                  </label>
                </div>
              </div>
            </div>
            <div className="modal-footer d-flex justify-content-center">
              {canWriteValue === true ?
                <button type="submit" className="deployment-button">
                  <i class="fa-solid fa-check done-container"></i>
                  {editOwnerTypeData ? t("Update") : t("Save")}
                </button>
                : ''}
            </div>
          </form>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default withTranslation()(OwnerType);
